@if ( isLoggedIn$ | async) {
<div class="main-container">
  <mat-toolbar class="mainToolBar">
    <img src="/assets/Reg-ent_Logo_640x200.jpg"  class="logo"/>

    <button
      [class.disabled]="isModalOpen"
      class="report-issue-button"
      matTooltip="Report Issue"
      (click)="openReportIssue()">
      <span class="person-alert-icon">
        <mat-icon class="person-alert-base">person</mat-icon>
        <mat-icon class="person-alert-badge">report_problem</mat-icon>
      </span>
    </button>

    <span class="myspacer"></span>


   <app-org-switcher></app-org-switcher>
   <mat-icon *ngIf="(currentIcon$ | async) != ''" >{{ currentIcon$ | async }}</mat-icon>
   <span *ngIf="(currentPageLabel$ | async) != ''" class="currentPageLabel">{{ currentPageLabel$ | async }}</span>

    <button
      [class.disabled]="isModalOpen"
      mat-icon-button
      [matMenuTriggerFor]="menu">
      <mat-icon>
        menu
      </mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item disabled class="menu-label">{{ (activeUser$ | async)?.displayName}}</button>

      @for (item of (menuItems$ | async); track item.label) {
        <button [class.disabled]="isModalOpen"  mat-menu-item [routerLink]="item.route">
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </button>
      }
      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
     
    </mat-menu>
  </mat-toolbar>


  <main class="app-main">
  @if (idleWarning$ | async) {
    <p>{{ idleWarningText$ | async }}</p>
    <mat-progress-bar
      [color]="'warn'"
      mode="determinate"
      [value]='idleValuePercent$ | async'>
    </mat-progress-bar>

  }
  <router-outlet ></router-outlet>

  </main>
</div>


} @else {

<div id="spinner-container" class="main-container">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate">
  </mat-progress-spinner>
</div>


}
